import React from 'react';
import ReactDOM from 'react-dom/client';
import HomeInspectionApp from './HomeInspectionApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HomeInspectionApp />
  </React.StrictMode>
);